import { render, staticRenderFns } from "./AccesosRegistros.vue?vue&type=template&id=4e11fcde&scoped=true"
import script from "./AccesosRegistros.vue?vue&type=script&lang=js"
export * from "./AccesosRegistros.vue?vue&type=script&lang=js"
import style0 from "./AccesosRegistros.vue?vue&type=style&index=0&id=4e11fcde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e11fcde",
  null
  
)

export default component.exports